const INITIAL_STATE = {
    country: [],
    autocomplete: [],
    results: [],
    getSearch:{ "tramos": [{time:"0600"}],"edades": [{ ageInput: '' }] },
    //getSearch:{ "tramos": [{}],"edades": [{ ageInput: '' }, { ageInput: '' }, { ageInput: '' }, { ageInput: '' }] },
    requestSearch:[],

};
export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case "GET_AUTOCOMPLETE":
            return {...state,autocomplete:action.payload}
        case "GET_REQUESTCOUNTRY":
            return {...state,country:action.payload}
        case "SAVE_REQUEST":
            return {...state,requestSearch:action.payload}
        case "GET_SEARCH":
            return {...state,getSearch:action.dataRequest,preload:false}
        case "GET_SEARCH_PASSES":
            return {...state,getSearch:action.dataRequest,preload:false}
        default:
            return state;
    }
}

